import React from "react";
import ReactDOM from 'react-dom'
//import cn from "classnames";

//component styles
import classes from "./UserNotice.module.scss";

function UserNotice(props) {
  const { closeNotice, asDialog } = props;

  const domEl = document.getElementById('modal-root')
  if (!domEl) return null

  return ReactDOM.createPortal(
    (
      <>
        {asDialog
          ? <div className={classes.container}></div>
          : null}

        <div className={classes.notice}>
          <div className={classes.content}>
            {props.children}
          </div>
        </div>
      </>
    ), domEl);
}

export default React.memo((UserNotice));